import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../../microservice/components/CardWrapper';
// import config from '../components/config';
import '../../container/Box/Components/Box-Style.css'
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;
// Titlecloudcompute
function SimpleUrlENG() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Simple-Url-Shortener")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Simple URL Shortener:</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">A URL shortener provides a shortened URL for long web addresses that include many characters, symbols, and numbers: PURLs (Personalized URLs).</p>
                                <p class="typo-14">(Example) <u>abc.vora.net/desk/marketing/survey.html?id=a3bc65cd</u> </p>
                                <p class="typo-14">- Using a default domain: =&gt; sus.so/aB2b3Aza </p>
                                <p class="typo-14">- Using a custom domain: =&gt; 자사도메인/aB2b3Aza </p>
                                <br></br>
                                <p class="typo-14">A short and easy-to-read URL is provided: Users can recognize the original website from the shortened URL.</p>
                                <p class="typo-14">- Using a default domain: =&gt; sus.so/brandname/uniquekeyword (e.g., help, sales, marketing, etc.) </p>
                                <p class="typo-14">- Using a custom domain: =&gt; customdomain/uniquekeywordn(e.g., help, sales, marketing, etc.) </p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">PURLs (Personalized URLs)</p></BoxTitle>
                            <BoxText  >
                                <p class="typo-14">- In marketing campaigns, a unique web URL address and content are provided for each individual recipient.</p>
                                <p class="typo-14">- Each PURL is a personalized, unique website link. </p>
                                <p class="typo-14">- When personalized text, images, offers, or surveys are presented, marketing managers can track online responses or participation.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/* {CardWrap("<p class='typo-21 typo-medium typo-black'>Email / SMS 마케팅시 단축 URL 사용 예</p>", "", "", "https://hanbiro.com/cloud/library2/simple-url-shortener/simple-url-shortener-1.svg")} */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Example of Using Shortened URLs in Email / SMS Marketing</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/simple-url-shortener/simple-url-shortener-1.svg"></ImageWrap>
                        </BoxContent>
                        {/*CardWrap("• 가격",config.tb8_header,config.tb8_content)*/}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            <FooterEn />
        </Sysfont>
    );
};

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxSubText = styled.div`
  margin-left: 7%;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`
export default SimpleUrlENG;